<template>
  <v-container fluid class="my-5">
    <MesaDirectivaSolicitudes />
  </v-container>
</template>

<script>
import MesaDirectivaSolicitudes from '@/components/mesaDirectiva/MesaDirectivaSolicitudes.vue'

export default {
  name: 'mesa_directiva_solicitudes',
  components: {
    MesaDirectivaSolicitudes
  }
}
</script>
